import { FC } from 'react';
import { Button, Svg } from '@altermaind/web/ui';
import { PropsArrow } from './types';

export const NextArrow: FC<PropsArrow> = ({ onClick, isLast, closeDialog }) => {
  return (
    <Button
      variant='positive'
      onClick={isLast ? closeDialog : onClick}
      style={{
        position: 'absolute',
        right: 0,
        bottom: '-45px',
        zIndex: 1,
        transform: 'translateY(-50%)',
      }}
      backgroundColor='transparent'
      aria-label='Next'
      minWidth='auto'
      height='fit-content'
      py='none'
      px='xxs'
      pr='none'
    >
      <Svg name='chevronRight' size='s' />
    </Button>
  );
};
